module.exports = __webpack_public_path__ + "static/media/badge-gp.e74258fd.png";